import { render, staticRenderFns } from "./toggle-switch.vue?vue&type=template&id=5cc78c54&scoped=true&"
import script from "./toggle-switch.vue?vue&type=script&lang=js&"
export * from "./toggle-switch.vue?vue&type=script&lang=js&"
import style0 from "./toggle-switch.vue?vue&type=style&index=0&id=5cc78c54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc78c54",
  null
  
)

export default component.exports